import { Box, Typography } from '@mui/material'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { RADIUS } from '@/shared/styles/radii'
import { ICON_SIZE, UI_FONT_SIZE } from '@/shared/styles/typography'

/**
 * 通信不安定 (= recoverable). MediaRecorder fallback で録音継続中だが、 streaming 経路は閉じた状態.
 * 28 spec §4.7 警告バナー (= warnBg/warnFg/warnIcon, 8px 12px padding, RADIUS.md, label fontSize).
 */
export const InterruptionRecoverableBanner = () => (
  <Box
    sx={{
      backgroundColor: colorTokens.state.warnBg,
      color: colorTokens.state.warnFg,
      borderRadius: `${RADIUS.md}px`,
      py: 1,
      px: 1.5,
      display: 'flex',
      gap: 1,
      alignItems: 'flex-start',
    }}
  >
    <WarningAmberRoundedIcon
      sx={{
        color: colorTokens.state.warnIcon,
        fontSize: ICON_SIZE.md,
        flexShrink: 0,
      }}
    />
    <Typography
      component="span"
      sx={{
        fontSize: UI_FONT_SIZE.label,
        lineHeight: 1.4,
      }}
    >
      タブ切り替え等により通信が不安定です。低速モードに切り替わりました。
    </Typography>
  </Box>
)
